import { Component, Input, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Constants } from '../../constants';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material';
import { ResultDialogComponent } from '../result-dialog/result-dialog.component';
import { LowBalanceDialogComponent } from '../low-balance-dialog/low-balance-dialog.component';

import { LoadingService, UserService } from '@core/services';

import { fadeAnimation } from '../../app.animations';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    animations: [fadeAnimation]
})

export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() isNavLogin: boolean;

    @ViewChild('email') emailInput;

    user: FormGroup;
    userObject: any;
    subscription: Subscription;
    errorFlag: boolean;
    errorMessage: string = "Error";
    rememberMe? = false;
    hasNotValidated: boolean = false;

    constructor(private _userService: UserService,
                private _router: Router,
                private _http: Http,
                private _loading: LoadingService,
                private dialog: MatDialog) {
    }

    ngOnInit() {
        this.user = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email]),
            // password: new FormControl('', [Validators.required, Validators.minLength(6)]),
            password: new FormControl('', [Validators.required]),
            rememberMe: new FormControl()
        });
        this.subscription = this._userService.getUser().subscribe(user => {
            this.userObject = user;
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    ngAfterViewInit() {
      setTimeout(() => this.emailInput.nativeElement.focus(), 0);
    }

    onSubmit(): void {
        this._loading.showLoader();
        if (this.user.value.rememberMe) {
            this.rememberMe = this.user.value.rememberMe;
        }
        const login = this.setUpLoginData();

      var cache_break = Date.now() / 1000;
      this._http.post(login.url + "?cb=" + cache_break, login.formData, login.options)
            .map((response) => response.json())
            .subscribe((data) => {
                    if (data.emailConfirmed !== "False") {
                        this.defineCurrentUser(data);
                        this._loading.hideLoader();
                        this.errorFlag = false;
                        //setTimeout(() => this.checkAccountBalance(), 1500);
                    }
                    else {
                        this.hasNotValidated = true;
                        this.errorFlag = false;
                    }
                },
                error => {
                    this.hasNotValidated = false;
                    // Sets appropriate error message based on http status code number
                    switch (error.status) {
                        case 400:
                            this.errorMessage = "Invalid email/password, please try again";
                            break;
                        case 500:
                            this.errorMessage = "Server error, please try again later";
                            break;
                        default:
                            this.errorMessage = "Error, please try again later";
                            break;
                    }

                    this._loading.hideLoader();
                    this.errorFlag = true;
                },
                () => {
                    this._loading.hideLoader();
                }
            );
    }

    private setUpLoginData() {
        const formData = 'grant_type=password&userName=' + encodeURIComponent(this.user.value.email) + '&password=' + encodeURIComponent(this.user.value.password);
        const url = Constants.NEXPRESS_LOGIN_ENDPOINT + Constants.TOKEN;
        const headers = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        return {formData, url, options: new RequestOptions({headers: headers})};
    }

    private defineCurrentUser(data) {
        this.setRememberMe(data);

        this._userService.setUserData(data);
        // We set the user in the user service; get that user
        // this._authGuard.getCurrentUser();
        this._router.navigateByUrl('/account');
    }

    private setRememberMe(data) {
        if (this.rememberMe) {
            localStorage.setItem(Constants.TOKEN, data.access_token);
            localStorage.setItem(Constants.EXPIRATION, data['.expires']);
        } else {
            sessionStorage.setItem(Constants.TOKEN, data.access_token);
            sessionStorage.setItem(Constants.EXPIRATION, data['.expires']);
        }
    }

    // checks if account balance is below threshold, alerts user with dialog of low balance
    private checkAccountBalance() {
      if(this.userObject && this.userObject.accountSummaryArray) {
        if(this.userObject.accountSummaryArray[0].AccountBalance < 5) {
          let dialogRef = this.dialog.open(LowBalanceDialogComponent, {
            data: {
              message: 'You have a zero dollar account balance, please make a payment',
              alertType: 'danger',
              title: 'Low Account Balance'
            }
          });
        }
      }
    }


}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/login/login.component.ts